import React from 'react';
import { useTranslation } from 'react-i18next';
import { isOverdue } from 'utils/dateUtils';

interface ExpensesStatusProps {
  status: 'approved' | 'pending' | 'rejected' | 'coming' | 'overdue';
  text?: string;
  dateDue?: string;
}

const ExpensesStatusBadge: React.FC<ExpensesStatusProps> = ({ status, text, dateDue }) => {
  const { t } = useTranslation();

  const getBadgeStatus = () => {
    switch (status) {
      case 'approved':
        return 'success';
      case 'coming':
        return 'info';
      case 'overdue':
        return 'danger';
      case 'rejected':
        return 'danger';
      default:
        return 'danger';
    }
  };

  const getDefaultText = () => {
    switch (status) {
      case 'approved':
        return t('expenses_status.approved');
      case 'coming':
        return t('expenses_status.coming');
      case 'overdue':
        return t('expenses_status.overdue');
      case 'rejected':
        return t('expenses_status.rejected');
      default:
        return t('unknown');
    }
  };

  return (
    <span className={`badge badge-soft-${getBadgeStatus()} d-inline-flex align-items-center`}>
      <i className="ti ti-circle-filled fs-5 me-1"></i>
      {text || getDefaultText()}
    </span>
  );
};

export default ExpensesStatusBadge;